import styled from 'styled-components'

export const Section = styled.section`
  margin-bottom: 16rem;

  @media (max-width: 1279px) {
    margin-bottom: 14rem;
  }

  @media (max-width: 767px) {
    margin-bottom: 12rem;
  }
`

export const TabsWrapper = styled.div`
  margin-bottom: 6rem;

  div {
    width: 50.3rem;
    border-radius: 10rem;
  }

  span {
    height: 4rem;
  }

  label {
    display: flex;
    align-items: center;
    height: 4rem;
    font-family: Navigo, Arial, Helvetica, sans-serif;
    font-size: 1.4rem;
    line-height: 2rem;

    &:not(:last-child) {
      margin-right: 3px !important;
    }
  }

  @media (max-width: 767px) {
    overflow-x: auto;
    scrollbar-width: none;
  }
`
export const Title = styled.h4`
  font-family: coolvetica, Arial, Helvetica, sans-serif;
  font-size: 2.4rem;
  line-height: 3rem;
  font-weight: 400;
  color: #292e3d;
  margin: 0;

  @media (max-width: 767px) {
    font-size: 2rem;
    line-height: 2.6rem;
  }
`

export const Header = styled.div`
  margin-bottom: 4rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 2rem;
  }
`

export const Link = styled.a`
  font-family: Navigo, Arial, Helvetica, sans-serif;
  font-size: 1.6rem;
  line-height: 2.4rem;
  color: #3a64f8;
  font-weight: 400;
  display: flex;
  align-items: center;
  gap: 1rem;
  transition: 0.2s ease-in-out;

  svg {
    position: relative;
    top: 2px;
    transform: translateX(0);
    transition: 0.2s ease-in-out;
  }

  &:hover {
    color: #6b8bfa;
  }
  &:hover svg {
    transform: translateX(3px);
  }
`
